import { ITypeSwitcherState } from '../types';

export const TYPE_SWITCHER_LOCALSTORAGE = 'TYPE_SWITCHER_LOCALSTORAGE';

export interface ITypeSwitcherLocalStorage extends ITypeSwitcherState{
};
